import { initializeApp } from 'firebase/app';
import { getAuth, connectAuthEmulator } from 'firebase/auth';
import { getFirestore, connectFirestoreEmulator } from 'firebase/firestore';
import { getStorage, connectStorageEmulator } from 'firebase/storage';
import { getFunctions, connectFunctionsEmulator } from 'firebase/functions';

const firebaseConfig = {
  apiKey: "AIzaSyAiSE6-KADSOOWL_MUBsNxSO6_LX3gNHKw",
  authDomain: "reservation-platform-prod.firebaseapp.com",
  projectId: "reservation-platform-prod",
  storageBucket: "reservation-platform-prod.firebasestorage.app",
  messagingSenderId: "203844526826",
  appId: "1:203844526826:web:4bb14afee5c9d44e2f2d93",
  measurementId: "G-L2P9CJM7XE"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize services
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const functions = getFunctions(app, 'asia-northeast1');
export const functionsUS = getFunctions(app, 'us-central1'); // US region for translation

/**
 * エミュレータ接続。
 *
 * これが無かったため、動作確認が常に本番データに対して行われていた。
 * 壊れた伝票や中途半端な会計が本番に溜まり、
 * 「テストしたらバグだらけ」の状態がそのまま残っていた。
 *
 * 使い方: shop-dashboard/.env.local に
 *   REACT_APP_USE_EMULATOR=true
 * を置いて npm start する。ビルド成果物には影響しない。
 */
// 本番ビルドでは必ず切る。
//
//   もとは REACT_APP_USE_EMULATOR だけを見ていた。
//   .env.local はローカル用のつもりだったが、react-scripts build も
//   .env.local を読む。手元に置いてあるだけで本番の出荷物に
//   「127.0.0.1:8080 に繋ぐ」処理が焼き込まれていた。
//
//   さらに悪いことに、この判定は最小化のときに畳まれず、if ごと残っていた。
//   実際に公開中の予約ページと店舗ダッシュボードは、閲覧者のブラウザから
//   127.0.0.1 に繋ぎに行っていた。作った本人の手元では
//   エミュレータが動いているので普通に見えてしまい、気づけなかった。
//
//   NODE_ENV は react-scripts が "production" という文字列に置き換えるので、
//   本番ビルドでは条件が定数の偽になり、この節ごと消える。
export const usingEmulator =
  process.env.NODE_ENV !== 'production' &&
  process.env.REACT_APP_USE_EMULATOR === 'true';

if (usingEmulator) {
  const host = process.env.REACT_APP_EMULATOR_HOST || '127.0.0.1';
  connectFirestoreEmulator(db, host, Number(process.env.REACT_APP_FIRESTORE_EMULATOR_PORT || 8080));
  connectAuthEmulator(auth, `http://${host}:${process.env.REACT_APP_AUTH_EMULATOR_PORT || 9099}`, {
    disableWarnings: true,
  });
  connectFunctionsEmulator(functions, host, Number(process.env.REACT_APP_FUNCTIONS_EMULATOR_PORT || 5001));
  connectFunctionsEmulator(functionsUS, host, Number(process.env.REACT_APP_FUNCTIONS_EMULATOR_PORT || 5001));
  try {
    connectStorageEmulator(storage, host, Number(process.env.REACT_APP_STORAGE_EMULATOR_PORT || 9199));
  } catch {
    // Storage エミュレータが動いていなくても他は使えるようにする
  }
  // 本番と取り違えないよう、画面からも分かるようにしておく
  // eslint-disable-next-line no-console
  console.warn('[エミュレータ接続中] 本番データには書き込みません');
}

export default app;
